import { Avatar, Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useLocalization } from '~/framework';
import { useDebounced } from '@dozuki/web-js/components';
import { useUsersSearch } from './useUsersSearch';
import {
   Catalog,
   CatalogItem,
   CatalogItemContent,
   InfiniteScrollForIncrementalQuery,
   SearchForm,
} from '~/ui-components';

type UserSearchInputProps = {
   onChange: (userid: number) => void;
};

export function UserSearchInput({ onChange }: UserSearchInputProps) {
   const [searchTerm, setSearchTerm] = useState('');
   const debouncedSearchTerm = useDebounced(searchTerm, 500);
   const usersQuery = useUsersSearch(debouncedSearchTerm, 5);
   const { flattenedData: users } = usersQuery;
   const { _js } = useLocalization();

   return (
      <Flex direction="column" mt={4}>
         <SearchForm
            placeholder={_js('Search Users')}
            name="search-users"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
         />
         <InfiniteScrollForIncrementalQuery query={usersQuery} contained height={300}>
            {users?.length === 0 && (
               <Flex flex={1} flexDirection="column" align="center" justify="center">
                  <Text variant="subtitle">{_js('There are no users to display')}</Text>
                  {debouncedSearchTerm.length > 3 && (
                     <Text variant="muted">{_js('Try searching for something different.')}</Text>
                  )}
               </Flex>
            )}
            <Catalog>
               {users?.map(user => (
                  <CatalogItem key={user.userid} onClick={() => onChange(user.userid)}>
                     <Avatar src={user.image?.thumbnail} />
                     <CatalogItemContent>
                        <Text variant="subtitle">{user.username}</Text>
                     </CatalogItemContent>
                  </CatalogItem>
               ))}
            </Catalog>
         </InfiniteScrollForIncrementalQuery>
      </Flex>
   );
}
